/** @file Key button (K): the current pose of chosen bones as setKey commands at the playhead frame. */
import { POSE_LAYOUT as L } from '@pose2d/core/contracts/pose';
import type { CommandCall, Id } from '@pose2d/format/types';

const KEYED = [['rotation', L.ROTATION], ['x', L.X], ['y', L.Y], ['scaleX', L.SCALE_X], ['scaleY', L.SCALE_Y]] as const;

/** rotation, x, y, scaleX and scaleY of each bone read from `local` (Pose.local: setup + animation, absolute). */
export function keyBonesCalls(animation: Id, frame: number, bones: readonly { id: Id; index: number }[], local: ArrayLike<number>): CommandCall[] {
  return bones.flatMap((bone) =>
    KEYED.map(([channel, offset]) => ({
      name: 'animation.setKey',
      input: { animation, target: bone.id, channel, frame: Math.round(frame), value: local[bone.index * L.LOCAL_STRIDE + offset] ?? 0 },
    })),
  );
}
